import React from 'react'
import { useNavigate } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'
import {Link} from 'react-router-dom';

const SignInForm = ({ handleInput, formData, loading,address, address2 }) => {
  const navigate = useNavigate()

  return (
    <>    
     <InputGroup
        label="Name"
        name="name"
        type="name"
        required={true}
        placeholder={'Enter your name'}
        value={formData.name}
        onChange={handleInput}
      />
      <InputGroup>
        <label></label>
        <InputGroup
        label="Weights"
        type="range"
        name="weights"
        required={true}
        min="0" max="50"
        value={formData.weights?formData.weights: 0 }
        onChange={handleInput}
      />
      <div style={{marginTop:-35, width:70}}>
      <InputGroup
        value={formData.weights?`${formData.weights}kg`: `0kg`}
      />
      </div>
      </InputGroup>
      <InputGroup>
        <label>Delivery Priority</label>
        <select name="delivery_priority" value={formData.priority} onChange={handleInput} style={{backgroundColor:"#313446"}}>
          <option value="">Select delivery priority</option>
          <option value="3">High</option>
          <option value="2">Medium</option>
          <option value="1">Low</option>
        </select>
      </InputGroup>
      {formData.delivery_priority == "3" && 
      <InputGroup
        label="Pick a date"
        type="date"
        name="delivery_priority_date"
        required={true}
        placeholder={'Select delivery priority'}
        value={formData.delivery_priority_date}
        onChange={handleInput}
      />
      }
      <InputGroup>
        <label>Description</label>
        <textarea name="description" onChange={handleInput} value={formData.description} placeholder={'Give a description on your order'} />
      </InputGroup>

      <InputGroup>
        <label>Orders details</label>
        <div className="orderDetail__container">
          <p>
            <span>Pick address:</span>{address}
          </p>
          <p>
            <span>Drop off address:</span>{address2}
          </p>
          <p>
            <span>Weights:</span>{formData.weights} kg
          </p>
          <p>
            <span>Total Amount:</span> {formData.amount}
          </p>
          <p>
            <span>Date:</span> 16 November 2020
          </p>
          <p>
            <span>Description:</span> {formData.description}
          </p>
        </div>
      </InputGroup>
      <Button
        full
        className="auth--btn"
        type="submit"
        loading={loading}
        spinnerWithTxt={true}
      >
        Next
      </Button>
       <div className="Link" style={{textAlign:"center", marginTop:10}}>
                <Link to="/delievery-request/step-1">
                    PREVIOUS
                </Link>
                </div>
    </>
  )
}

export default SignInForm
